<template>
    <SoliForm
        ref="contactForm"
        @submit="submitContactForm()"
        @reset="resetContactForm()"
        :persistent="true"
        :title="programInquiry ? 'Great Choice!' : 'Contact Us!'"
        :textSubtitle="
            programInquiry
                ? `We're excited to get you started in ${programInquiry}! Please submit your information and a community manager will get back to you shortly.`
                : `We'll get back to you shortly`
        "
    >
        <template #body>
            <v-container class="px-0">
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="contactForm.first_name"
                            prepend-inner-icon="person"
                            label="First Name"
                            outlined
                            :rules="[(v) => !!v || 'First name is required']"
                            dense
                            hide-details
                            class="py-05"
                        ></v-text-field
                    ></v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="contactForm.last_name"
                            :prepend-inner-icon="
                                $vuetify.breakpoint.xs ? 'person' : null
                            "
                            label="Last Name"
                            outlined
                            :rules="[(v) => !!v || 'Last name is required']"
                            dense
                            class="py-05"
                        ></v-text-field
                    ></v-col>
                </v-row>
                <BookingEmail v-model="contactForm.email" />
                <SoliPhone
                    @input="$emit('input', $event)"
                    :errors="errors.phone"
                    v-model="contactForm.phone"
                    :hideDetails="programInquiry ?? false"
                />
                <v-textarea
                    v-if="!programInquiry"
                    v-model="contactForm.comments"
                    class="soli-round"
                    outlined
                    label="Any questions?"
                    hide-details="auto"
                />
            </v-container>
        </template>
    </SoliForm>
</template>

<script>
import BookingEmail from "../../Components/Booking/BookingEmail.vue";

export default {
    components: {
        BookingEmail,
    },
    props: {
        guest: {
            type: Object,
            default: () => {},
        },
        child: {
            type: Object,
            default: () => {},
        },
        programInquiry: {
            type: String,
            default: null,
        },
        location: {
            type: Object,
            default: null,
        },
        instrument_id: {
            type: Number,
            default: null,
        },
        errors: {},
    },
    data() {
        return {
            loading: false,
            contactForm: this.$inertia.form({
                phone: this.guest.phone,
                first_name: this.guest.first_name,
                last_name: this.guest.last_name,
                email: this.guest.email,
                comments: null,
                instrument_id:
                    this.child?.instrument_id ?? this.guest.instrument_id,
                location_id: this.guest.location_id,
                has_child: this.guest.has_child,
                online: this.guest.online,
                child_first_name: this.child?.first_name,
                child_last_name: this.child?.last_name,
                child_birthday: this.child?.birthday,
                contact_only: true,
                lesson_id: this.guest.lesson_id,
                // need to switch this to program_id, but can just merge in request for now
                program_name: this.programInquiry,
                virtual_client: this.guest.virtual_client,
            }),
        };
    },
    methods: {
        submitContactForm() {
            if (!this.$refs.contactForm.$refs.form.validate()) return;
            this.loading = true;

            this.contactForm.post(route("getStarted.storeGuest"), {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    this.loading = false;
                },
                onError: (errors) => {
                    this.loading = false;
                    console.log(
                        "Form returned errors: " + JSON.stringify(errors)
                    );
                    if (errors.contactSupport) return;
                    if (errors.soliError) return;
                },
            });
        },
        resetContactForm() {
            this.$emit("reset");
        },
        blurInput() {
            document.activeElement.blur();
        },
    },
};
</script>
